import React, { useState } from "react";
import "../../detailModalWrapper/detailModal/DetailModal.css";
import moment from "moment";

const ChatBoxLeftChat: React.FC<{
  fullWidth: boolean,
  item: any
}> = ({fullWidth, item}) => {
  return (
    <div className="DetailModal-main-middle-view-chat-right-body-left" >
      <div className="DetailModal-main-middle-view-chat-right-body-left-dp">
        <div className="DetailModal-main-middle-view-chat-right-body-left-dp-circle">
          <img src="/assets/bg/6.png" alt="" />{item.sender?.substring(0,1)}
        </div>
        <h5>{item.sender}</h5>
        <h6>Customer</h6>
      </div>
      <div className="DetailModal-main-middle-view-chat-right-body-left-msg" style={{width: fullWidth ? '80%' : '75%' }} >
        <h6>{item.text}</h6>
        <div
          className="d-flex"
          style={{
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <div className="DetailModal-main-middle-view-chat-right-body-left-msg-time">
            {moment(item.created).format('DD.MM.YYYY')}
          </div>
          <div className="d-flex">
            <div className="DetailModal-main-middle-view-chat-right-body-left-msg-time">
            {moment(item.created).format('HH:mm')}
            </div>
            <img
              src="/assets/bg/8.png"
              alt=""
              style={{ width: 15, height: 15, marginLeft: 10 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBoxLeftChat;
